import Show from 'containers/CompanyProfile/Show';

export default { Show };
